export const LINK_ATTACHMENT_FORM_NAME_FIELD_PLACEHOLDER = 'link-attachment-form.name-field-placeholder';
export const LINK_ATTACHMENT_FORM_LINK_FIELD_PLACEHOLDER = 'link-attachment-form.link-field-placeholder';
export const LINK_ATTACHMENT_FORM_INVALID_URL_ERROR_MESSAGE = 'link-attachment-form.invalid-url-error-message';
export const LINK_ATTACHMENT_FORM_REQUIRED_ERROR_MESSAGE = 'link-attachment-form.required-error-message';
export const LINK_ATTACHMENT_FORM_SUBMIT_BUTTON_LABEL = 'link-attachment-form.submit-button-label';
export const LINK_ATTACHMENT_FORM_CANCEL_BUTTON_LABEL = 'link-attachment-form.cancel-button-label';
